// Phase 24B — Order report
import TransactionReportPage from "./TransactionReportPage";
import SourcePerfWidget from "@/components/reports/SourcePerfWidget";

export default function OrderReport() {
  return (
    <TransactionReportPage
      slug="order"
      testidPrefix="order-report"
      title="Order Report"
      subtitle="One row per order line, with who placed it (field, distributor or admin) and its fulfilment status."
      initialDaysBack={30}
      filterConfig={{ showUser: true, showDistributor: true }}
      headerWidget={(filters) => <SourcePerfWidget filters={filters} />}
    />
  );
}
